import React from 'react'
import { Form } from 'react-bootstrap'
import './InputText.scss'

interface InputTextProps {
  value?: string | number
  onChange?: (value: string) => void
  disabled?: boolean
  title?: string
  hint?: string
  placeholder?: string
  error?: string
  autocomplete?: string
  type?: string
}

export const InputText: React.FC<InputTextProps> = ({
  value = '',
  onChange,
  disabled = false,
  title,
  hint,
  placeholder,
  error,
  autocomplete = 'off',
  type = 'text',
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value)
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && type !== 'textarea') {
      e.stopPropagation()
    }
  }

  return (
    <div className={`mb-3 ${error ? 'pb-3' : ''}`}>
      {title && (
        <label className="form-label mb-2" htmlFor="inputId">
          {title}
        </label>
      )}
      <div className="position-relative">
        <Form.Control
          type={type}
          id="inputId"
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          placeholder={placeholder}
          autoComplete={autocomplete}
          isInvalid={!!error}
        />
        {hint && <small className="form-text text-muted" dangerouslySetInnerHTML={{ __html: hint }}></small>}
        {error && <div className="invalid-feedback position-absolute top-100">{error}</div>}
      </div>
    </div>
  )
}
